<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="mb-6 section-anchor">
    <template v-if="level === 0">
      <div :id="slugify(syarat.title)" class="text-h6 font-weight-bold mb-1"
        style="font-size: 1.5rem !important; font-family: Poppins !important">
        {{ syarat.title }}
      </div>
      <div v-if="syarat.last_update" class="text-caption font-italic mt-1"
        style="font-size: 0.875rem !important; font-family: Poppins !important">
        Terakhir diperbarui pada tanggal {{ convertDate(syarat.last_update) }}
      </div>
    </template>

    <template v-else-if="level === 1">
      <div class="font-weight-bold my-2" style="font-size: 1rem !important; font-family: Poppins !important">
        {{ index }}. {{ syarat.title }}
      </div>
    </template>

    <template v-else>
      <div class="font-weight-bold text-body-1 mb-1"
        style="font-size: 1rem !important; font-family: Poppins !important">
        {{ index }}. {{ syarat.title }}
      </div>
    </template>

    <div v-if="syarat.description" class="text-body-2 mb-2 text-justify"
      style="font-size: 1rem !important; font-family: Poppins !important" v-html="syarat.description"></div>

    <v-divider v-if="level === 0" class="my-4" :thickness="1" opacity="1" color="base"></v-divider>

    <div v-if="syarat.explanation && syarat.explanation.length > 0" class="mb-4">
      <div v-for="(item, i) in syarat.explanation" :key="i" class="d-flex mb-1 ms-4 text-body-2">
        <span class="me-2" style="font-size: 1rem !important; font-family: Poppins !important">{{ i + 1 }}.</span>
        <span style="font-size: 1rem !important; font-family: Poppins !important" v-html="item"></span>
      </div>
    </div>

    <template v-if="syarat.contents && syarat.contents.length > 0">
      <div :class="{ 'ms-0': level === 0, 'ms-2': level > 0 }">
        <syarat-ketentuan-item v-for="(content, iSyarat) in syarat.contents" :key="content.sk_id" :index="iSyarat + 1"
          :syarat="content" :level="level + 1"></syarat-ketentuan-item>
      </div>
    </template>
  </div>
</template>

<script>
import { utcToLocale } from "@/utils/dateFormatter";

export default {
  props: {
    syarat: {
      type: Object,
      default: () => ({
        title: "",
        description: "",
        explanation: [],
        contents: [],
      }),
    },
    index: {
      type: Number,
      default: null,
    },
    level: {
      type: Number,
      default: 0,
    },
  },

  methods: {
    slugify(text) {
      return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "");
    },
    convertDate(isoDate) {
      return utcToLocale(isoDate, "DD MMMM YYYY");
    },
  },
};
</script>
